import * as React from 'react'
import { FC, useState, useRef, useEffect, useCallback } from 'react'
import { VMTitleCategorySong } from '../../../index'
import { Audio } from '../../../Icons/'
import AudioPlayer from './AudioPlayer'

import './TitleSongs.scss'

interface Props {
    title: string
    songs: VMTitleCategorySong[]
}

const TitleSongs: FC<Props> = ({ title, songs }) => {
    return (
        <article className="TitleSongs typo">
            <h2>{title}</h2>
            {songs.map((song, index) => (
                <div key={index} className="TitleSongs__song">
                    <div className="TitleSongs__title">
                        <p>“{song.name}”</p>
                        <AudioPlayer file={song.file} />
                    </div>
                    <div className="TitleSongs__description">
                        <p>{song.composer}</p>
                    </div>
                </div>
            ))}
        </article>
    )
}

export default TitleSongs
